
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import BtnRadio from "@/components/scope/btn-radio.vue";
import FilterBar from "./components/filter-bar.vue";
import echarts from "echarts";
import appCode from "@common/src/utils/app-code";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import TextTips from "@common/src/components/scope/text-tips/index.vue";

const statement = namespace("statement");
const base = namespace("base");
const management = namespace("management");
const serviceItem = namespace("service-item");
const parts = namespace("parts");
@Component({
  components: { BtnRadio, FilterBar, TextTips },
  filters: {}
})
export default class Statement extends Vue {
  @statement.Action getTurnOverAnalysisModel;
  @base.Action getDictionaryList;
  @management.Action getStoreList;
  @serviceItem.Action getServiceItemList;
  @parts.Action getPartsList;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm: any = {
    storeCode: "", // 门店名称
    area: "", // 所在地区
    stateName: "", // 省级名称
    cityName: "", // 市级名称
    districtName: "", // 县级名称
    timeFrameType: "", // 时间范围类型, date-按日,month-按月
    startTime: "", // 开始时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    endTime: "", // 结束时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    businessType: "", // 服务类型，services-服务项目,parts-零配件
    businessCodeList: [] // 服务编码列表
  };
  contentList: any = [];
  pieChartRadio: any = "0";
  barChartRadio: any = "0";

  created() {
    if (localStorage.getItem("searchFormData")) {
      let data = JSON.parse(localStorage.getItem("searchFormData"));
      localStorage.removeItem("searchFormData");
      this.searchForm = data;
    } else {
      if (appCode === "speedbiz-operation") {
        this.searchStore("");
      } else if (appCode === "speedbiz") {
        this.searchService("");
        this.searchParts("");
      }
      this.getCurrentTime();
    }
    this.init();
  }
  getCurrentTime() {
    // 获取当前时间
    let timestamp = new Date().getTime() - 24 * 60 * 60 * 1000;
    let currentTime = new Date(timestamp);
    let year = String(currentTime.getFullYear());
    let month = this.addZero(currentTime.getMonth() + 1);
    let day = this.addZero(currentTime.getDate());
    this.searchForm.timeFrameType = "date";
    this.searchForm.startTime = year + month + "01";
    this.searchForm.endTime = year + month + day;
  }
  addZero(num) {
    return num < 10 ? "0" + num : String(num);
  }

  storeList: any = [];
  serviceList: any = [];
  partsList: any = [];
  get searchList() {
    if (localStorage.getItem("searchListData")) {
      let data = JSON.parse(localStorage.getItem("searchListData"));
      localStorage.removeItem("searchListData");
      data.forEach(item => {
        if (item.type === "select-view") {
          item.selectList.forEach(part => {
            if (part.value === "services") {
              this.serviceList = part.itemSelectList;
              part.itemSelectList = this.serviceList;
              part.itemSearchFun = this.searchService;
            }
            if (part.value === "parts") {
              this.partsList = part.itemSelectList;
              part.itemSelectList = this.partsList;
              part.itemSearchFun = this.searchParts;
            }
          });
        }
      });
      return data;
    }
    let storeRow = [
      {
        label: t("v210831.store-name"),
        type: "select-search",
        value: "",
        prop: "storeCode",
        selectList: this.storeList,
        searchFun: this.searchStore
      },
      {
        label: t("setting.region"),
        type: "area",
        value: "",
        labels: [],
        prop: "area",
        anyLevel: true,
        labelWidth: "85px"
      }
    ];
    let timeRow = [
      {
        label: t("v210831.time-frame"),
        type: "select-view",
        value: "",
        prop: "timeFrameType",
        // 时间范围区间必须是同一年
        isSameYear: true,
        selectList: [
          {
            value: "date",
            label: t("v210831.query-by-day"),
            itemValue: "",
            itemType: "daterange",
            itemProp: "dateValue",
            itemValueFormat: "yyyyMMdd"
          },
          {
            value: "month",
            label: t("v210831.query-by-month"),
            itemValue: "",
            itemType: "monthrange",
            itemProp: "dateValue",
            itemValueFormat: "yyyyMM"
          }
        ]
      }
    ];
    let eventRow = [
      {
        label: t("v211030.project-spare-parts-screening"),
        type: "select-view",
        value: "",
        prop: "businessType",
        labelWidth: "120px",
        selectList: [
          {
            value: "services",
            label: t("finance.service-items"),
            itemValue: [],
            itemType: "select-search",
            itemProp: "businessCodeList",
            itemSelectList: this.serviceList,
            itemSearchFun: this.searchService
          },
          {
            value: "parts",
            label: t("parts.text"),
            itemValue: [],
            itemType: "select-search",
            itemProp: "businessCodeList",
            itemSelectList: this.partsList,
            itemSearchFun: this.searchParts
          }
        ]
      }
    ];
    if (appCode === "speedbiz-operation") {
      return [...storeRow, ...timeRow];
    } else if (appCode === "speedbiz") {
      timeRow[0]["labelWidth"] = "120px";
      return [...timeRow, ...eventRow];
    }
    return [];
  }
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
  searchService(val = "") {
    this.getServiceItemList({
      status: "1",
      pageNum: 1,
      pageSize: 10,
      searchKey: val
    }).then(data => {
      this.serviceList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.serviceName;
            item.value = item.serviceCode;
            return item;
          })
        : [];
      console.log(this.serviceList, 3333333331);
    });
  }
  searchParts(val = "") {
    this.getPartsList({
      status: "1",
      pageNum: 1,
      pageSize: 10,
      partsName: val
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.partsName;
        item.value = item.partsCode;
        return item;
      });
    });
  }
  init() {
    this.getChartData();
  }
  dataLastUpdateTime: any = "";
  chartServerData: any = {};
  getChartData() {
    this.getTurnOverAnalysisModel(this.searchForm).then(data => {
      if (data.data.dataLastUpdateTime) {
        this.dataLastUpdateTime = data.data.dataLastUpdateTime;
      }

      let { orderNumberStatistics, orderNumberMonthlyList, orderCollectionMonthlyList } = data.data;
      this.chartServerData = data.data;
      this.handlePieChange("0");
      this.handleBarChange("0");
      console.log(data.data, t("v210831.chart"));
      /**
       * @refName
       *  饼图 实收金额   -----payAmountStatistics
       *  饼图 订单金额   -----orderAmountStatistics
       *  pieNumberChart  饼图 台次   -----orderNumberStatistics
       *  柱状图 实收金额   -----payAmountMonthlyList
       *  柱状图 订单金额   -----orderAmountMonthlyList
       *  barNumberChart  柱状图 台次   -----orderNumberMonthlyList
       *  lineChart  折线图   -----orderCollectionMonthlyList
       */
      let pieNumberChartData = {
        data: [
          {
            name: t("dashboard.repair-maintenance"),
            value: orderNumberStatistics.maintenanceNumber
          },
          {
            name: t("dashboard.wash-order"),
            value: orderNumberStatistics.carWashNumber
          },
          {
            name: t("dashboard.retail-order"),
            value: orderNumberStatistics.retailNumber
          }
        ],
        total: orderNumberStatistics.totalNumber,
        text: t("v210831.summary-of-sets"),
        tip: t("v210831.number-of-sets"),
        isNumber: true
      };
      this.setChart(pieNumberChartData, "pieNumberChart", "pie");

      let barNumberChartData = {
        data1: orderNumberMonthlyList.map(v => v.maintenanceNumber),
        data2: orderNumberMonthlyList.map(v => v.carWashNumber),
        data3: orderNumberMonthlyList.map(v => v.retailNumber),
        originData: orderNumberMonthlyList,
        unit: t("v210831.number-of-sets"),
        isNumber: true
      };
      this.setChart(barNumberChartData, "barNumberChart", "bar");
      let lineChartData = {
        data1: orderCollectionMonthlyList.map(v => (v.orderAmount ? Number(v.orderAmount) : null)),
        data2: orderCollectionMonthlyList.map(v => (v.payAmount ? Number(v.payAmount) : null)),
        data3: orderCollectionMonthlyList.map(v => (v.onAccountAmount ? Number(v.onAccountAmount) : 0)),
        data4: orderCollectionMonthlyList.map(v => (v.retailDiscountAmount ? Number(v.retailDiscountAmount) : 0)),
        originData: orderCollectionMonthlyList,
        unit: this.$localMark.currency
      };
      this.setChart(lineChartData, "lineChart", "line");
    });
  }
  setChart(data, refName, type) {
    let xAllArr = [
      t("v210831.january"),
      t("v210831.february"),
      t("v210831.march"),
      t("v210831.april"),
      t("v210831.may"),
      t("v210831.june"),
      t("v210831.july"),
      t("v210831.august"),
      t("v210831.september"),
      t("v210831.october"),
      t("v210831.november"),
      t("v210831.december")
    ];
    let xAxisData = [];
    if (data.originData) {
      let firstMonth = Number(data.originData[0].monthParam.split("-")[1]);
      xAxisData = xAllArr.slice(firstMonth - 1, firstMonth - 1 + data.originData.length);
    }
    let MyChart = echarts.init(this.$refs[refName]);
    let options = {};
    if (type === "pie") {
      // 饼图pie
      options = {
        color: ["#2278F5", "#00B478", "#FFC300"],
        tooltip: {
          trigger: "item",
          formatter: params => {
            return `${params.name}<br/>${data.tip}: ${data.isNumber ? params.value : splitThousands(params.value)}(${
              params.percent
            }%)`;
          }
        },
        legend: {
          bottom: "0%",
          left: "center",
          x: "center",
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 24
        },
        title: {
          show: true,
          text: data.text,
          subtext: splitThousands(data.total),
          top: "43%",
          left: "center",
          textStyle: {
            color: "rgba(0, 0, 0, 0.45)",
            fontWeight: 400,
            fontSize: 12
          },
          subtextStyle: {
            color: "rgba(0, 0, 0, 0.85)",
            fontWeight: 500,
            fontSize: 18
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            // minAngle: 5,
            label: {
              show: false
            },
            data: data.data
          }
        ]
      };
    } else if (type === "bar") {
      // 柱状图bar
      options = {
        color: ["#2278F5", "#00B478", "#FFC300"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: params => {
            let str = `${data.originData[params[0].dataIndex].monthParam}<br/>`;
            params.forEach(item => {
              str += `${item.marker}${item.seriesName}: ${
                data.isNumber ? item.value : splitThousands(item.value)
              }<br/>`;
            });
            return str;
          }
        },
        legend: {
          data: [t("dashboard.repair-maintenance"), t("dashboard.wash-order"), t("dashboard.retail-order")],
          bottom: "0%",
          left: "center",
          x: "center",
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 24
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true
            },
            data: xAxisData
          }
        ],
        yAxis: [
          {
            axisTick: { show: false },
            type: "value"
          }
        ],
        series: [
          {
            name: t("dashboard.repair-maintenance"),
            type: "bar",
            barGap: 0,
            data: data.data1,
            barWidth: data.data1.length < 5 ? 40 : null
          },
          {
            name: t("dashboard.wash-order"),
            type: "bar",
            data: data.data2,
            barWidth: data.data2.length < 5 ? 40 : null
          },
          {
            name: t("dashboard.retail-order"),
            type: "bar",
            data: data.data3,
            barWidth: data.data3.length < 5 ? 40 : null
          }
        ]
      };
    } else if (type === "line") {
      // 折线图line
      options = {
        color: ["#2278F5", "#00B478", "#FFC300", "#f74e3b"],
        tooltip: {
          trigger: "axis",
          formatter: params => {
            let str = `${data.originData[params[0].dataIndex].monthParam}<br/>`;
            params.forEach(item => {
              str += `${item.marker}${item.seriesName}: ${" " + splitThousands(item.value)}<br/>`;
            });
            return str;
          }
        },
        legend: {
          data: [t("v213.Order"), t("v210831.paid-in-amount"), t("v213.On-account"), t("v213.Discount")],
          bottom: "0%",
          left: "center",
          x: "center",
          itemGap: 24
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true
            },
            data: xAxisData
          }
        ],
        yAxis: [
          {
            axisTick: { show: false },
            type: "value"
          }
        ],
        series: [
          {
            name: t("v213.Order"),
            type: "line",
            barGap: 0,
            data: data.data1
          },
          {
            name: t("v210831.paid-in-amount"),
            type: "line",
            data: data.data2
          },
          {
            name: t("v213.On-account"),
            type: "line",
            data: data.data3
          },
          {
            name: t("v213.Discount"),
            type: "line",
            data: data.data4
          }
        ]
      };
    }
    MyChart.setOption(options);
    window.addEventListener("resize", () => {
      MyChart.resize();
    });
  }
  handlePieChange(value) {
    this.pieChartRadio = value;
    const refName = "orderTypePieChart";
    const tabTypeDataMap = {
      "0": "payAmountStatistics",
      "1": "orderAmountStatistics",
      "2": "onAccountAmountStatistics",
      "3": "discountAmountStatistics"
    };
    const textDataMap = {
      "0": {
        text: addCurrencyUnit(t("v210831.total-paid-in"), false, true),
        tip: t("v210831.paid-in-amount")
      },
      "1": {
        text: addCurrencyUnit(t("v210831.total-order-amount"), false, true),
        tip: t("v213.Order")
      },
      "2": {
        text: addCurrencyUnit(t("v213.On-account"), false, true),
        tip: t("v213.On-account")
      },
      "3": {
        text: addCurrencyUnit(t("v213.Discount"), false, true),
        tip: t("v213.Discount")
      }
    };
    const chartData = {
      data: [
        {
          name: t("dashboard.repair-maintenance"),
          value: this.chartServerData[tabTypeDataMap[value]].maintenanceAmount
        },
        {
          name: t("dashboard.wash-order"),
          value: this.chartServerData[tabTypeDataMap[value]].carWashAmount
        },
        {
          name: t("dashboard.retail-order"),
          value: this.chartServerData[tabTypeDataMap[value]].retailAmount
        }
      ],

      total: this.chartServerData[tabTypeDataMap[value]].totalAmount,
      ...textDataMap[value]
    };
    this.setChart(chartData, refName, "pie");
  }
  handleBarChange(value) {
    this.barChartRadio = value;
    const refName = "monthlyOrderTypeBarChart";
    const tabTypeDataMap = {
      "0": "payAmountMonthlyList",
      "1": "orderAmountMonthlyList",
      "2": "onAccountAmountMonthlyList",
      "3": "discountAmountMonthlyList"
    };
    const textDataMap = {
      "0": {
        originData: this.chartServerData[tabTypeDataMap[value]],
        unit: this.$localMark.currency
      },
      "1": {
        originData: this.chartServerData[tabTypeDataMap[value]],
        unit: this.$localMark.currency
      },
      "2": {
        originData: this.chartServerData[tabTypeDataMap[value]],
        unit: this.$localMark.currency
      },
      "3": {
        originData: this.chartServerData[tabTypeDataMap[value]],
        unit: this.$localMark.currency
      }
    };
    const chartData = {
      data1: this.chartServerData[tabTypeDataMap[value]].map(v => v.maintenanceAmount),
      data2: this.chartServerData[tabTypeDataMap[value]].map(v => v.carWashAmount),
      data3: this.chartServerData[tabTypeDataMap[value]].map(v => v.retailAmount),
      total: this.chartServerData[tabTypeDataMap[value]].totalAmount,
      ...textDataMap[value]
    };
    this.setChart(chartData, refName, "bar");
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "area") {
          this.searchForm.stateName = item.labels[0] || "";
          this.searchForm.cityName = item.labels[1] || "";
          this.searchForm.districtName = item.labels[2] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
        if (item.type === "select-view") {
          item.selectList.forEach(val => {
            if (val.value === item.value) {
              if (val.itemProp === "dateValue") {
                this.searchForm.startTime = val.itemValue[0] || "";
                this.searchForm.endTime = val.itemValue[1] || "";
              } else {
                this.searchForm[val.itemProp] = val.itemValue;
              }
            }
          });
        }
      }
    });
    this.getChartData();
  }
}
